import _merge from 'lodash/merge';
import intl from 'react-intl-universal';

const KEY_OTHER_TO_PDF_CUSTOM_SETTING_TYPES = 'other_to_pdf_custom_setting_types';
const KEY_OTHER_TO_PDF_CUSTOM_SETTINGS_ = 'other_to_pdf_custom_settings_';

export const previewRate = 0.756 * 0.5;//0.756 = pdf size / html size, 0.5 = make ui same like phantom

export const CONVERT_OBJECT_EXCEL = 'Excel';
export const CONVERT_OBJECT_POWERPOINT = 'PowerPoint';
export const CONVERT_OBJECT_VISIO = 'Visio';
export const CONVERT_OBJECT_WORD = 'Word';

export const CONVERT_OBJECTS = [
  { value: CONVERT_OBJECT_EXCEL, label: 'OfficeExcel' },
  { value: CONVERT_OBJECT_POWERPOINT, label: 'OfficePowerPoint' },
  { value: CONVERT_OBJECT_VISIO, label: 'OfficeVisio' },
  { value: CONVERT_OBJECT_WORD, label: 'OfficeWord' },
];

export const SETTING_TYPE_HIGHQUALITYPRINT = 'HighQualityPrint';
export const SETTING_TYPE_PDFA1B = 'PDFA1b';
export const SETTING_TYPE_SMALLESTFILESIZE = 'SmallestFileSize';
export const SETTING_TYPE_STANDARD = 'Standard';
export const SETTING_TYPE_USPTO = 'USPTO';

export const SETTING_TYPES = [
  SETTING_TYPE_HIGHQUALITYPRINT,
  SETTING_TYPE_PDFA1B,
  SETTING_TYPE_SMALLESTFILESIZE,
  SETTING_TYPE_STANDARD,
  SETTING_TYPE_USPTO,
];

export const UNITS = [
  { value: 'inch', label: 'Inch', label1: 'In' },
  { value: 'cm', label: 'Centimeter', label1: 'Cm' },
  { value: 'mm', label: 'Millimeter', label1: 'Mm' },
];

export const PAGE_WIDTH = 210;//unit mm
export const PAGE_HEIGHT = 297;//unit mm

export const getValueByUnit = (val, from, to) => {
  const getUnitByName = window.PDFViewCtrl.shared.getUnitByName;
  val = parseFloat(val);
  if (isNaN(val) || val === 0) {
    return 0;
  }
  if (from !== to) {
    val = getUnitByName(from).convertTo(val, getUnitByName(to));
  }
  return val;
}

export const getCustomSettings = convertObject => {
  let defaultSettings;
  switch (convertObject) {
    case CONVERT_OBJECT_EXCEL:
    case CONVERT_OBJECT_POWERPOINT:
    case CONVERT_OBJECT_WORD:
      defaultSettings = {
        settingType: SETTING_TYPE_STANDARD,
      };
      break;
    case CONVERT_OBJECT_VISIO:
      defaultSettings = {
        settingType: SETTING_TYPE_HIGHQUALITYPRINT,
      };
      break;
    default:
      defaultSettings = {};
  }
  const customSettings = JSON.parse(localStorage.getItem(`${KEY_OTHER_TO_PDF_CUSTOM_SETTINGS_}${convertObject}`) || '{}');
  return { ...defaultSettings, ...customSettings };
};

export const setCustomSettings = (convertObject, customSettings) => {
  localStorage.setItem(`${KEY_OTHER_TO_PDF_CUSTOM_SETTINGS_}${convertObject}`, JSON.stringify(customSettings));
};

function permissionCalculator(security) {
  const { print = 0, accessibility = false, change = 0, copy = false } = security || {};
  const securityUtils = window.UIExtension.PDFViewCtrl.shared.securityUtils;
  return securityUtils.convertUIDataToPermission({
    print: Number(print),
    accessibility: Boolean(accessibility),
    copy: Boolean(copy),
    change: Number(change),
  });
}

export const getApiParams = convertObject => {
  const customSettings = getCustomSettings(convertObject);
  if (!Object.keys(customSettings).length) return {};

  const settings = getCustomSettingTypeInfo(customSettings.settingType);
  const params = {
    isFastWebView: settings.general.isFastWebView,
    general: {
      type: 0,
    },
    standards: {
      type: 2,
    },
  };
  if (settings.general.convert_to_version !== 'default') {
    params.general.convert_to_version = settings.general.convert_to_version;
  }
  if (settings.standards.convert_to_version !== 'none') {
    params.standards.convert_to_version = settings.standards.convert_to_version;
  }
  if (settings.waterMark.add) {
    params.waterMark = {
      flagOnTopOfPage: 1,
      type: settings.waterMark.type,
      opacity: settings.waterMark.opacity,
      rotation: settings.waterMark.rotation,
    }
    if (settings.waterMark.type === 'textObject') {
      params.waterMark.offsetX = getValueByUnit(settings.waterMark.offsetXText, settings.waterMark.units, 'pt');
      params.waterMark.offsetY = getValueByUnit(settings.waterMark.offsetYText, settings.waterMark.units, 'pt');
      params.waterMark.font = {
        text: settings.waterMark.text,
        fontName: settings.waterMark.fontName,
        size: settings.waterMark.fontSize,
        color: settings.waterMark.fontColor,
      };
    } else {
      params.waterMark.offsetX = getValueByUnit(settings.waterMark.offsetXImage, settings.waterMark.units, 'pt');
      params.waterMark.offsetY = getValueByUnit(settings.waterMark.offsetYImage, settings.waterMark.units, 'pt');
      params.waterMark.image = settings.waterMark.image;
      params.waterMark.scale = settings.waterMark.scale;
    }
  }
  if (settings.headerFooter.add) {
    params.headerFooter = {
      font: {
        fontName: settings.headerFooter.fontName,
      },
      fontSize: settings.headerFooter.fontSize,
      color: settings.headerFooter.fontColor,
      headerLeft: settings.headerFooter.headerLeft,
      headerCenter: settings.headerFooter.headerCenter,
      headerRight: settings.headerFooter.headerRight,
      footerLeft: settings.headerFooter.footerLeft,
      footerCenter: settings.headerFooter.footerCenter,
      footerRight: settings.headerFooter.footerRight,
      left: getValueByUnit(settings.headerFooter.left, settings.waterMark.units, 'pt'),
      right: getValueByUnit(settings.headerFooter.right, settings.waterMark.units, 'pt'),
      top: getValueByUnit(settings.headerFooter.top, settings.waterMark.units, 'pt'),
      bottom: getValueByUnit(settings.headerFooter.bottom, settings.waterMark.units, 'pt'),
    }
  }
  if (settings.security.type === 'passwordProtection') {
    params.security = {
      cipher: settings.security.cipher,
      is_encrypt_metadata: settings.security.is_encrypt_metadata,
    };
    if (settings.security.requireUserPassword) {
      params.security.userPassword = settings.security.userPassword;
    }
    if (settings.security.requireOwnerPassword) {
      params.security.ownerPassword = settings.security.ownerPassword;
      params.security.user_permissions = permissionCalculator(settings.security);
    }
  }
  return params;
};

export const getCustomSettingTypeInfo = settingType => {
  const settingsStandard = {
    general: {
      description: intl.get('ConvertToPDF.Settings.Description.Standard'),
      isFastWebView: true,
      convert_to_version: 'default',
    },
    standards: {
      convert_to_version: 'none',
    },
    waterMark: {
      add: false,
      type: 'textObject',
      text: '',
      fontName: 'courier',
      fontSize: 10,
      fontColor: '#000000',
      image: {},
      opacity: 50,
      rotation: 0,
      units: 'inch',
      offsetXText: 0,
      offsetYText: 0,
      offsetXImage: 0.04,
      offsetYImage: 0.04,
      scale: 50,
    },
    headerFooter: {
      add: false,
      fontName: 'courier',
      fontSize: 10,
      fontColor: '#000000',
      editType: 'header',
      headerLeft: '',
      headerCenter: '',
      headerRight: '',
      footerLeft: '',
      footerCenter: '',
      footerRight: '',
      units: 'inch',
      left: 1,
      right: 1,
      top: 0.5,
      bottom: 0.5,
    },
    security: {
      type: 'noProtection',
      requireUserPassword: false,
      userPassword: '',
      userPassword1: '',
      requireOwnerPassword: false,
      ownerPassword: '',
      ownerPassword1: '',
      print: 0,
      change: 0,
      copy: false,
      accessibility: false,
      cipher: 2,
      is_encrypt_metadata: false,
    }
  };

  const customSettingTypes = JSON.parse(localStorage.getItem(KEY_OTHER_TO_PDF_CUSTOM_SETTING_TYPES) || '{}');

  let settings = {};
  if (settingType === SETTING_TYPE_HIGHQUALITYPRINT) {
    _merge(settings, settingsStandard, {
      general: {
        description: intl.get('ConvertToPDF.Settings.Description.HighQualityPrint'),
      }
    });
  } else if (settingType === SETTING_TYPE_PDFA1B) {
    _merge(settings, settingsStandard, {
      standards: { convert_to_version: 1 },
      general: {
        convert_to_version: 14,
        isFastWebView: false,
        disableFastWebView: true,
        description: intl.get('ConvertToPDF.Settings.Description.PDFA1b'),
      }
    });
  } else if (settingType === SETTING_TYPE_SMALLESTFILESIZE) {
    _merge(settings, settingsStandard, {
      general: {
        description: intl.get('ConvertToPDF.Settings.Description.SmallestFileSize'),
      }
    });
  } else if (settingType === SETTING_TYPE_STANDARD) {
    _merge(settings, settingsStandard);
  } else if (settingType === SETTING_TYPE_USPTO) {
    _merge(settings, settingsStandard, {
      general: {
        convert_to_version: 14,
        isFastWebView: false,
        description: intl.get('ConvertToPDF.Settings.Description.USPTO'),
      }
    });
  } else if (Object.keys(customSettingTypes).length) {
    const customSettings = customSettingTypes[settingType] || {};
    settings = {
      ...settingsStandard,
      ...customSettings,
    }
  }

  return settings;
};

export const setCustomSettingTypeInfo = (settingType, customSettings) => {
  const customSettingTypes = JSON.parse(localStorage.getItem(KEY_OTHER_TO_PDF_CUSTOM_SETTING_TYPES) || '{}');
  customSettingTypes[settingType] = customSettings;
  localStorage.setItem(KEY_OTHER_TO_PDF_CUSTOM_SETTING_TYPES, JSON.stringify(customSettingTypes));
};

export const getCustomSettingTypes = () => {
  const customSettingTypes = JSON.parse(localStorage.getItem(KEY_OTHER_TO_PDF_CUSTOM_SETTING_TYPES) || '{}');
  return Object.keys(customSettingTypes);
};

export const getAllSettingTypes = () => {
  return [...SETTING_TYPES, ...getCustomSettingTypes()];
};

export const defaultActiveKey = 'General';

export const SettingCategories = {
  General: 'General',
  PDFStandards: 'PDFStandards',
  Watermarks: 'Watermarks',
  HeadersFooters: 'HeadersFooters',
  Security: 'Security',
}
